export enum ToolHeadState {
  DRAFT = 'new',
  ACTIVE = 'on',
  INACTIVE = 'off',
}
